<dx-popup (onHidden)="this.onHidden()"
          height="66vh"
          [visible]="this.visible"
          [width]="this.getWidth()"
          resizeEnabled="true"
          dragEnabled="true"
          title="Sync Hedges With Client's State"
>
  <div *dxTemplate="let data of 'content'" class="container">
    
    <div class="content">
      <div class="trans-state">
        <dx-scroll-view>
          <div class="state">
            <div class="row" *ngFor="let row of this.callRows">
              <div class="row-title" [style.color]="row.color">
                {{ row.label }}
              </div>
              <div class="row-data">
                <div class="col before">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="5">Former</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Qty</td>
                      <td>Side</td>
                      <td>Type</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.before" class="row" [style.color]="row.color">
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                      <td>{{ leg.type }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
                <div class="col separator" [style.background-color]="row.color">&nbsp;</div>
                <div class="col transaction">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="4">Transaction</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Action</td>
                      <td>Qty</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.transaction" class="row" [style.color]="row.color">
                      <td>{{ leg.operation }}</td>
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
                <div class="col separator" [style.background-color]="row.color">&nbsp;</div>
                <div class="col after">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="5">Current</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Qty</td>
                      <td>Side</td>
                      <td>Type</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.after" class="row" [style.color]="row.color">
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                      <td>{{ leg.type }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <hr class="divider">
          <div class="state" *ngIf="this.hasPutRows">
            <div class="row" *ngFor="let row of this.putRows">
              <div class="row-title" [style.color]="row.color">
                {{ row.label }}
              </div>
              <div class="row-data">
                <div class="col before">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="5">Before</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Qty</td>
                      <td>Side</td>
                      <td>Type</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.before" class="row" [style.color]="row.color">
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                      <td>{{ leg.type }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
                <div class="col separator" [style.background-color]="row.color">&nbsp;</div>
                <div class="col transaction">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="4">Transaction</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Action</td>
                      <td>Qty</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.transaction" class="row" [style.color]="row.color">
                      <td>{{ leg.operation }}</td>
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
                <div class="col separator" [style.background-color]="row.color">&nbsp;</div>
                <div class="col after">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="5">After</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Qty</td>
                      <td>Side</td>
                      <td>Type</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.after" class="row" [style.color]="row.color">
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                      <td>{{ leg.type }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </dx-scroll-view>
      </div>
      <div class="buttons">
        <div class="btn">
          <dx-button width="100%" text="Apply Former" (onClick)="this.applyState('former')"
          ></dx-button>
        </div>
        <div class="btn">&nbsp;</div>
        <div class="btn">
          <dx-button width="100%" text="Apply Current" (onClick)="this.applyState('current')"></dx-button>
        </div>
      </div>
    </div>
  </div>
  
</dx-popup>

